import { sendAnalyticsEvent, UnknownEvent } from '@faststore/sdk'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'

export const TopCategorySection = () => {
  const { topCategory } = useGlobalNavigation()
  const { dispatch } = useMenu()

  const handleAnalytics = (label: string) => {
    if (!label) return

    sendAnalyticsEvent<UnknownEvent>({
      name: 'menu_categorie',
      params: {
        path: '',
        section: 'hamb_menu',
        main_category: label,
      },
    })
  }

  return (
    <div
      className="bg-[#F7F5F5] pl-3 pr-6 pb-6 pt-4 border-t-4 border-solid border-[#F0F0F0] [&>a:last-child]:mb-0"
      onMouseEnter={() => dispatch({ type: 'reset' })}
    >
      {topCategory.map((el, index: number) => (
        <a
          key={`top-category-section-item-${index}`}
          href={el?.titleURL}
          className="py-3 flex flex-row gap-3 items-center justify-between mb-1 px-6 no-underline cursor-pointer text-black hover:underline"
          onClick={() => handleAnalytics(el?.title)}
        >
          <div className="flex flex-row gap-2 items-center max-w-[calc(100%-36px)]">
            <div className="block w-6 h-6 min-w-[24px] min-h-[24px]">
              <img
                className="max-w-full"
                src={el?.logoImage}
                alt={`img-${el?.title}`}
              />
            </div>
            <div className="max-w-full overflow-hidden">
              <span className="block text-sm font-normal tracking-[-0.42px] text-[#232323]">
                {el?.title}
              </span>
            </div>
          </div>
        </a>
      ))}
    </div>
  )
}
